import React, { Component, Fragment } from 'react';
import * as Papa from 'papaparse';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Select from '@material-ui/core/Select';
import CircularProgress from 'material-ui/CircularProgress';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import UploadResults from './UploadResults'
import theme from '../../muiTheme';
import { filterIncidentsByState } from './uploadHelper';


const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  },
  formControl: {
   minWidth: 120
 },
};

export class StateUploadDialog extends Component
{
  constructor(props)
  {
     super(props);

     this.state =
     {
       selectedState: '',
       selectedCategory: 'WF',
       selectedStateName: '',
       canUploadIncidents: false,
       showCurrentStatus: false,
       currentStatusMessage: '',
       isUploading: false,
       showResults: false,
       resultObject: {}
     };
   }

    handleUploadCSV = () => {
      let input = this.refs.input_reader;
      input.click();
    }

    clearStatus = () => {
      this.setState({
          showCurrentStatus: false,
          currentStatusMessage: '',
          resultObject: {},
          showResults: false
      });
    }

    setCurrentStatus = (status) => {
      this.setState({
          showCurrentStatus: true,
          currentStatusMessage: status
      });
    }

   inputFileChanged = async (e) => {
      if(window.FileReader){
        this.setState({
          isUploading: true,
          canUploadIncidents: false
        });
          
          let file = e.target.files && e.target.files.length >0 ? e.target.files[0] : null;
          this.refs.input_reader.value = null;
          this.setCurrentStatus("Parsing records from CSV...");
          Papa.parse(file,
            {
              delimiter: "",	// auto-detect
              newline: "",	// auto-detect
              quoteChar: '"',
              escapeChar: '"',
              header: false,
              transformHeader: undefined,
              dynamicTyping: false,
              preview: 0,
              encoding: "",
              worker: false,
              comments: false,
              step: undefined,
              error: undefined,
              download: false,
              skipEmptyLines: true,
              chunk: undefined,
              fastMode: undefined,
              beforeFirstChunk: undefined,
              withCredentials: undefined,
              transform: undefined,
              complete: async (results,file)=>{
                this.setCurrentStatus("Validating data file. Keep browser window open to ensure all records are processed and results are displayed...");
                
                const indexesOutsideStateBuffer = await filterIncidentsByState(this.state.selectedState, results);

                this.setState({
                  isUploading: true,
                  canUploadIncidents: false
                });
                
                window.api.postStateUpload(file, indexesOutsideStateBuffer, this.state.selectedCategory).then(response => {
                    this.setState({
                      isUploading: false,
                      canUploadIncidents: false,
                      showResults: true,
                      resultObject: response,
                      showCurrentStatus: false
                    });
                });

              }
            });

         
      }
      else
      {
          console.error('Browser does not support File Reader');
      }
  }

   getMissingHeadersMessage = (validationStatus) =>
   {
     return "The following required headers were missing: " + validationStatus.MissingHeaders.join();
   }


  getHeaderRowForIncidents = (incident) =>
  {
    let headerRow = [];
    let attributes = incident.attributes;
    for (const property in attributes)
    {
      headerRow.push(property)
    }
    return headerRow;
  }


handleStateChange = (event) => {
  this.setState({
      selectedState: event.target.value,
      selectedStateName: event.target.selectedOptions[0].label,
      canUploadIncidents: (event.target.value !== '')
  });

  this.clearStatus();
}

handleCategoryChange = (event) => {
  this.setState({
      selectedCategory: event.target.value,
      canUploadIncidents: (event.target.value !== '' && this.state.selectedState !== '')
  });

  this.clearStatus();
}

render() {
    let progressNode = (this.state.isUploading) ? (<CircularProgress size={24} thickness={2} style={{padding: "5px 5px 5px 5px"}} />) : "";
    let labelNode = (this.state.showCurrentStatus) ? (<Fragment>{progressNode}<label style={{whiteSpace:'pre-line'}} >{this.state.currentStatusMessage}</label></Fragment>) : '';

    return (

      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="Upload State Incidents"
       open={this.props.open}>
              <DialogContent>
              <div style={{padding: "5px 5px 5px 5px"}}>
               <input type="file" ref="input_reader" accept=".csv" multiple={false} style={{display:'none'}} onChange={this.inputFileChanged}/>
               <FormGroup>
               <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">Incident Category:</FormLabel>
                  <Select
                  native
                  value={this.state.selectedCategory}
                  onChange={(event) =>
                    {
                      this.handleCategoryChange(event);
                    }}
                id="demo-simple-select-helper">
                <option value='WF'>Wildfire</option>
                <option value='RX'>Prescribed Fire</option>
                <option value='NS'>Non-Statistical/Other</option>
            </Select>
          </FormControl>
                 <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">State:</FormLabel>
                  <Select
                  native
                  value={this.state.selectedState}
                  onChange={(event) =>
                    {
                      this.handleStateChange(event);
                    }}
                id="demo-simple-select-helper">
                <option aria-label="None" value="" />
                <option value='AL'>Alabama</option>
                <option value='AK'>Alaska</option>
                <option value='AZ'>Arizona</option>
                <option value='AR'>Arkansas</option>
                <option value='CA'>California</option>
                <option value='CO'>Colorado</option>
                <option value='CT'>Connecticut</option>
                <option value='DE'>Delaware</option>
                <option value='FL'>Florida</option>
                <option value='GA'>Georgia</option>
                <option value='HI'>Hawaii</option>
                <option value='ID'>Idaho</option>
                <option value='IL'>Illinois</option>
                <option value='IN'>Indiana</option>
                <option value='IA'>Iowa</option>
                <option value='KS'>Kansas</option>
                <option value='KY'>Kentucky</option>
                <option value='LA'>Louisiana</option>
                <option value='ME'>Maine</option>
                <option value='MD'>Maryland</option>
                <option value='MA'>Massachusetts</option>
                <option value='MI'>Michigan</option>
                <option value='MN'>Minnesota</option>
                <option value='MS'>Mississippi</option>
                <option value='MO'>Missouri</option>
                <option value='MT'>Montana</option>
                <option value='NE'>Nebraska</option>
                <option value='NV'>Nevada</option>
                <option value='NH'>New Hampshire</option>
                <option value='NJ'>New Jersey</option>
                <option value='NM'>New Mexico</option>
                <option value='NY'>New York</option>
                <option value='NC'>North Carolina</option>
                <option value='ND'>North Dakota</option>
                <option value='OH'>Ohio</option>
                <option value='OK'>Oklahoma</option>
                <option value='OR'>Oregon</option>
                <option value='PA'>Pennsylvania</option>
                <option value='RI'>Rhode Island</option>
                <option value='SC'>South Carolina</option>
                <option value='SD'>South Dakota</option>
                <option value='TN'>Tennessee</option>
                <option value='TX'>Texas</option>
                <option value='UT'>Utah</option>
                <option value='VT'>Vermont</option>
                <option value='VA'>Virginia</option>
                <option value='WA'>Washington</option>
                <option value='WV'>West Virginia</option>
                <option value='WI'>Wisconsin</option>
                <option value='WY'>Wyoming</option>
                <option value='DC'>District of Columbia</option>
                <option value='AS'>American Samoa</option>
                <option value='GU'>Guam</option>
                <option value='MP'>Northern Mariana Islands</option>
                <option value='PR'>Puerto Rico</option>
                <option value='UM'>United States Minor Outlying Islands</option>
                <option value='VI'>Virgin Islands, U.S.</option>
            </Select>
          </FormControl>
                
          </FormGroup>
               
           </div>
            <div style={{display:'inline-block'} }>{labelNode}</div>
           <UploadResults
            isVisible={this.state.showResults}
            results={this.state.resultObject}
            />
      </DialogContent>
       <DialogActions>
        <Button onClick={() => {
            this.clearStatus();
            this.props.onCancelStateUpload();
        }} color="primary">
          Close
        </Button>
          <Button onClick={this.handleUploadCSV} color="primary" disabled={!this.state.canUploadIncidents}>
            Upload Incidents
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default StateUploadDialog;
